interface SelectionToolbarProps {
  count: number;
  onClear: () => void;
  onStartCampaign: () => void;
}

/**
 * The selection action bar — v6 `.action-bar` (SCRUM-353): a 10px-radius
 * RECTANGLE (rounded-tk-lg — the bar itself is not a pill; only the count is),
 * bg-4 with the gold `border-accent` border and shadow-lg, fixed 24px from the
 * viewport bottom and centered, with the 200ms rise-in. Appears only when ≥1
 * row is selected: "{N} selected · Clear · Start campaign for {N}".
 */
export function SelectionToolbar({ count, onClear, onStartCampaign }: SelectionToolbarProps) {
  if (count === 0) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-6 z-[99] flex justify-center">
      <div className="bg-bg-4 rounded-tk-lg shadow-tk-lg pointer-events-auto flex animate-[rise-in_200ms_cubic-bezier(0.16,1,0.3,1)] items-center gap-4 border border-[var(--border-accent)] px-4 py-3">
        <span className="bg-brand-dim text-brand-primary rounded-tk-full px-2.5 py-1 font-mono text-xs font-semibold tracking-[0.02em]">
          {count.toLocaleString('en-US')} selected
        </span>
        <button
          type="button"
          onClick={onClear}
          className="text-text-3 hover:text-text-0 px-1.5 py-1 text-xs transition-colors"
        >
          Clear
        </button>
        {/* v6 .btn-primary: WHITE text at weight 600 on the gold gradient. */}
        <button
          type="button"
          onClick={onStartCampaign}
          className="rounded-tk-md shadow-tk-sm inline-flex items-center gap-2 px-5 py-2.5 text-[0.8125rem] font-semibold text-white transition-all [background:var(--grad-cyan)] hover:-translate-y-px hover:[box-shadow:var(--tk-shadow-md),var(--tk-glow-sm)]"
        >
          Start campaign for {count.toLocaleString('en-US')}
        </button>
      </div>
    </div>
  );
}
